import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import push from "react-router-redux";
import { Form } from "antd";
import { Redirect } from "react-router-dom";
import { Spin } from "antd";
import { withFirestore, firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { isLoaded, isEmpty } from "react-redux-firebase";

import { RecipientFields as Fields } from "../common/labels/forms";
import AddRecipient from "./AddRecipient";
import { columns } from "../common/labels/tables";
import {
  saveRecipient,
  deleteRecipient,
  uploadCSVRecipient
} from "../../actions/recipient";

class index extends Component {
  state = {
    userId: this.props.userId,
    selected_count: 0,
    page: 1,
    start_count: 0,
    open: false,
    duplicates: this.props.duplicates,
    selections: {
      recipients: []
    },
    searchRecipients: "",
    filterRecipients: null,
    modalVisible: false,
    csvUpload: {
      group: null,
      file: null
    }
  };

  addRecipient = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      values["userId"] = [];
      values.userId = [this.props.userId];

      if (!err) {
        this.props.saveRecipient(values);
        this.props.form.resetFields();
      }
    });
  };

  deleteRecipient = recipient => {
    const { deleteRecipient } = this.props;
    deleteRecipient(recipient);
    this.setState({
      open: false,
      selected_count: 0,
      selections: { recipients: {} }
    });
  };

  confirm = () => this.deleteRecipient(this.state.selections.recipients);

  onOpen = () => this.setState({ open: true });
  onClose = () => this.setState({ open: false });
  onCancelModal = () => this.setState({ modalVisible: false });

  onChangePage = (event, data) => {
    const { activePage } = data;

    if (activePage !== this.state.page) {
      this.setState({ page: activePage });
    }
  };

  changePage = page => {
    this.props.dispatch(push("/?page=" + page));
  };

  onChange = info => {
    // if (info.file.status !== "uploading") {
    //   console.log(info.file, info.fileList);
    const reader = new FileReader();
    reader.onload = e => {
      const file = Object.assign(e.target.result).split(",,");

      this.setState({
        csvUpload: {
          ...this.state.csvUpload,
          file: file
        }
      });

      this.props.uploadCSVRecipient(this.state.csvUpload);
    };
    reader.readAsText(info);
    // reader.readAsText(info.file.originFileObj);
    // }
    this.props.form.resetFields();
  };

  handleSearch = event => {
    this.setState({
      searchRecipients: event.target.value.substr(0, 20)
    });
  };

  selectDropDownChange = value => {
    const filter =
      this.props.recipients &&
      this.props.recipients.filter(content =>
        content.group.toLowerCase().includes(value)
      );

    this.setState({
      filterRecipients: filter
    });
  };

  onChangeUploadGroup = e => {
    e.preventDefault();
    this.setState({
      csvUpload: {
        ...this.state.csvUpload,
        group: e.target.value
      }
    });
  };

  render() {
    const filteredRecipients =
      this.props.recipients &&
      this.props.recipients.filter(content => {
        const recip = Object.keys(content);

        return recip.some(key =>
          content[key]
            .toString()
            .toLowerCase()
            .includes(this.state.searchRecipients.toLowerCase())
        );
      });

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        const recip = _.map(selectedRows, "id");
        this.setState({
          selected_count: selectedRows.length,
          selections: { recipients: recip }
        });
      },

      onSelectAll: (selected, selectedRows, changeRows) => {
        if (selected) {
          const recip = filteredRecipients.map(recipient => recipient.id);
          this.setState({
            selections: { recipients: recip },
            selected_count: recip.length
          });
        }
      }
    };

    if (!isLoaded(this.props.auth)) {
      return (
        <div style={{ marginTop: 100, textAlign: "center" }}>
          <Spin size="large" />
        </div>
      );
    }

    if (isEmpty(this.props.auth)) {
      return <Redirect to="/login" />;
    }

    return (
      <div>
        <AddRecipient
          recipients={filteredRecipients}
          Fields={Fields}
          addRecipient={this.addRecipient}
          selectedRecipient={this.state.selections.recipients}
          onOpen={this.onOpen}
          onClose={this.onClose}
          confirm={this.confirm}
          modalState={this.state.open}
          uploadCSVRecipient={this.props.uploadCSVRecipient}
          changePage={this.changePage}
          columns={columns}
          rowSelection={rowSelection}
          getFieldDecorator={this.props.form.getFieldDecorator}
          state={this.state}
          userId={this.props.userId}
          Redirect={Redirect}
          onChange={this.onChange}
          handleSearch={this.handleSearch}
          selectDropDownChange={this.selectDropDownChange}
          onChangeUploadGroup={this.onChangeUploadGroup}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ firestore, firebase, recipients }) => {
  const stripe =
    firestore.ordered.stripe_customers &&
    firestore.ordered.stripe_customers[0].planName;

  return {
    recipients: firestore.ordered.recipients,
    auth: firebase.auth,
    userId: firebase.auth.uid,
    duplicates: recipients.recipientDuplicate,
    stripe: stripe
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveRecipient: contact => dispatch(saveRecipient(contact, ownProps)),
    deleteRecipient: contact => dispatch(deleteRecipient(contact, ownProps)),
    uploadCSVRecipient: contacts =>
      dispatch(uploadCSVRecipient(contacts, ownProps))
  };
};

const WrappedIndex = Form.create({ name: "recipient" })(index);

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  firestoreConnect(props => {
    return [
      {
        collection: "stripe_customers",
        where: [["userId", "==", props.auth.uid || null]]
      },
      {
        collection: "recipients",
        where: [["userId", "==", props.auth.uid || null]],
        limit:
          props.stripe && props.stripe === "Starter"
            ? 1000
            : props.stripe === "Pro"
            ? 2000
            : 3000,
      }
    ];
  })
)(WrappedIndex);
